import styled from "styled-components";

export const ButtonWrapper = styled.div`
  padding: ${({ theme }) => theme.space[1]};
`;
